// Bugfix 23 (#1393): zoekbalk en filters van het ledenoverzicht. Resultaten
// verversen terwijl je typt (na een korte pauze) en zodra een filter wijzigt,
// zonder aparte zoekknop. Het formulier ververst alleen de lijst.
import { Controller } from "stimulus"

export default class extends Controller {
  disconnect() {
    clearTimeout(this.timer)
  }

  zoek() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.verstuur(), 300)
  }

  direct(event) {
    event.preventDefault()
    clearTimeout(this.timer)
    this.verstuur()
  }

  verstuur() {
    verstuurZonderLegeVelden(this.element)
  }
}

// Lege velden gaan niet mee, zodat het adres in de adresbalk leesbaar blijft
// (?q=jarno in plaats van ?q=jarno&status=&programma=...). Turbo leest het
// formulier direct bij het versturen, dus daarna kunnen ze weer aan.
export function verstuurZonderLegeVelden(formulier) {
  const leeg = [...formulier.elements].filter((veld) => veld.name && !veld.disabled && veld.value === "")
  leeg.forEach((veld) => { veld.disabled = true })
  try {
    if (typeof formulier.requestSubmit === "function") {
      formulier.requestSubmit()
    } else {
      formulier.submit()
    }
  } finally {
    leeg.forEach((veld) => { veld.disabled = false })
  }
}
